import { Component } from '@angular/core';

@Component({
    selector: 'medialink',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class MediaLinkComponent {}
